module.exports = __webpack_public_path__ + "img/collection-weddingRingsMokumeGane@2x.e3622d1.jpg";